import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { Box, Button, Typography } from '@mui/material';
import WarningIcon from '../../assets/images/warning-icon.svg';
import { useAuth } from '../../hooks/useAuth';
export var AcessoNegadoPage = function () {
    var logout = useAuth().logout;
    var handleLogout = function () {
        logout();
    };
    return (_jsxs(Box, { sx: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: '11rem',
            textAlign: 'center',
            px: 3,
        }, children: [_jsx("img", { src: WarningIcon, alt: "Aten\u00E7\u00E3o", style: {
                    width: 80,
                    height: 80,
                    marginBottom: 16,
                } }), _jsx(Typography, { variant: "h5", mb: 2, align: "center", children: "Acesso restrito" }), _jsx(Typography, { variant: "body1", color: "textSecondary", mb: 3, align: "center", children: "Aten\u00E7\u00E3o! Voc\u00EA n\u00E3o tem permiss\u00E3o de acesso, entre em contato com administrador do sistema." }), _jsx(Button, { variant: "contained", color: "primary", onClick: function () { return window.location.reload(); }, sx: { mt: 3 }, children: "Atualizar" }), _jsx(Button, { variant: "outlined", color: "primary", startIcon: _jsx(ExitToAppIcon, {}), onClick: handleLogout, sx: { mt: 3 }, children: "Sair" })] }));
};
